import React from "react";
import { s } from "../styles";
import type { T4Item } from "../types";

interface ItemsProps {
  list: ReadonlyArray<T4Item>;
}

export default function Items({ list }: ItemsProps) {
  return (
    <>
      {list.map(([n, t]) => (
        <div key={n} style={s.ritem}>
          <b>{n}</b> &ndash; {t}
        </div>
      ))}
    </>
  );
}